export default "__VITE_ASSET__cBDf5rco__"